/** A MouthReader (speech-track.ts) on a worker of its own, for one library's model. */
import type { MouthReader } from './speech-track';
import type { Mouth, MouthModel } from './visemes';
import type { ReaderRequest } from './mouth-reader.worker';

export function workerReader(model: MouthModel, rate: number): { read: MouthReader; dispose(): void } {
  const worker = new Worker(new URL('./mouth-reader.worker.ts', import.meta.url), { type: 'module' });
  const pending = new Map<number, (mouths: Mouth[]) => void>();
  let next = 0;
  worker.onmessage = ({ data }: MessageEvent<{ id: number; mouths: Mouth[] }>) => {
    pending.get(data.id)?.(data.mouths);
    pending.delete(data.id);
  };
  const post = (request: ReaderRequest, transfer: Transferable[] = []) => worker.postMessage(request, transfer);
  post({ model });
  return {
    read: (pcm) =>
      new Promise((resolve) => {
        const id = next++;
        pending.set(id, resolve);
        const copy = pcm.slice(0); // the voice still plays this buffer: the worker gets its own
        post({ id, pcm: copy, rate }, [copy]);
      }),
    dispose: () => {
      worker.terminate();
      pending.forEach((resolve) => resolve([]));
      pending.clear();
    },
  };
}
